let menu = [
  // {
  //   title: "人员管理",
  //   link: "/personalManage",
  //   permiss: "page-personalManage",
  //   children: []
  // },
  {
    title: "页面管理",
    // permiss: "page-super",
    children: []
  },
  {
    title: "基本信息",
    // permiss: "page-super",
    children: [
      {
        title: "人员信息",
        link: "/basic/myMessage",
        permiss: "page-basic/myMessage",
        iconClass: "icon_mymessage"
      },
      {
        title: "网站基本配置",
        link: "/basic/websiteMessage",
        permiss: "page-basic/websiteMessage",
        iconClass: "icon_company"
      },
      {
        title: "枚举设置",
        link: "/basic/enumSetting",
        permiss: "page-basic/enumSetting",
        iconClass: "icon_special"
      }
    ]
  },
  {
    title: "网站管理",
    // permiss: "page-moduleManager",
    children: [
      {
        title: "菜单管理",
        link: "/module/moduleManager",
        permiss: "page-moduleManager/moduleManager",
        iconClass: "icon_classify"
      },
      {
        title: "底部导航管理",
        link: "/module/moduleBottomManager",
        permiss: "page-moduleManager/moduleBottomManager",
        iconClass: "icon_bottomnav"
      },
      {
        title: "轮播图管理",
        link: "/module/bannerManager",
        permiss: "page-moduleManager/bannerManager",
        iconClass: "icon_banner"
      },
      {
        title: "页面管理",
        link: "/module/moduleDetailManager",
        permiss: "page-moduleManager/moduleDetailManager",
        iconClass: "icon_page"
      },
      {
        title: "意见反馈管理",
        link: "/module/suggestionManager",
        permiss: "page-suggestionManager",
        iconClass: "icon_suggestion"
      }

      // {
      //   title: "页面文件管理",
      //   link: "/module/moduleDetailFileManager",
      //   permiss: "page-moduleManager/moduleDetailFileManager"
      // },
      // {
      //   title: "页面模块管理",
      //   link: "/module/moduleDetailSegmentManager",
      //   permiss: "page-moduleManager/moduleDetailSegmentManager"
      // },
      // {
      //   title: "页面特殊管理",
      //   link: "/module/moduleDetailSegmentSpecialManager",
      //   permiss: "page-moduleManager/moduleDetailSegmentSpecialManager"
      // }
    ]
  },
  {
    title: "统计管理",
    children: [
      {
        title: "访问统计",
        link: "/statistics/detailLogEchart",
        permiss: "page-detailLogEchart",
        iconClass: "icon_stcechart"
      },
      {
        title: "访问列表",
        link: "/statistics/detailLogManager",
        permiss: "page-detailLogManager",
        iconClass: "icon_stcmanager"
      }
    ]
  },
  {
    title: "公司管理",
    link: "/websiteManager",
    permiss: "page-websiteManager",
    children: []
  }

  // {
  //   title: "系统设置",
  //   // permiss: "page-main/permission",
  //   children: [
  //     {
  //       title: "权限管理",
  //       link: "/main/permission",
  //       permiss: "page-main/permission"
  //     }
  //   ]
  // },
  // {
  //   title: "超级管理",
  //   // permiss: "page-super",
  //   children: [
  //     {
  //       title: "公司管理",
  //       link: "/super/companyManage",
  //       permiss: "page-super/companyManage"
  //     },
  //     {
  //       title: "登录日志",
  //       link: "/super/handleDiary",
  //       permiss: "page-super/handleDiary"
  //     },
  //     {
  //       title: "资源管理",
  //       link: "/super/resourceMange",
  //       permiss: "page-super/resourceMange"
  //     },
  //     {
  //       title: "公司管理员管理",
  //       link: "/super/companyAdmin"
  //       permiss: "page-/super/companyAdmin",
  //     }
  //   ]
  // }
];
export default {
  menuTree: menu
};



// WEBPACK FOOTER //
// ./src/menu/index.js